import { render, staticRenderFns } from "./OrcPage_documents-view.vue?vue&type=template&id=21d6eb9a&"
import script from "./OrcPage_documents-view.vue?vue&type=script&lang=js&"
export * from "./OrcPage_documents-view.vue?vue&type=script&lang=js&"
import style0 from "./OrcPage_documents-view.vue?vue&type=style&index=0&id=21d6eb9a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports